import { useSlug } from '@common/hooks/use-slug'
import { useCreateErrand } from './use-create-errand'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useSlimStaticWebsite } from '@app/site/common/hooks/use-slim-static-website'
import { useErrandFeature } from './use-errand-feature'

interface FormData {
  body: string
  email: string
  phoneNumber: string
  errandTypeId: string

  apartmentNumber?: string
}

export const useContactForm = (onSuccess: () => void) => {
  const slug = useSlug()
  const { id, loading } = useSlimStaticWebsite(slug)
  const { errandTypes, hasErrandsFeature, errandInfo } = useErrandFeature(slug)
  const { createErrand } = useCreateErrand()

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<FormData>()

  const handleCreateErrand = (data: FormData) => {
    const { body, email, phoneNumber, errandTypeId, apartmentNumber } = data

    if (!id || !body || !email || !phoneNumber || !errandTypeId) {
      return
    }

    createErrand({
      body,
      email,
      phoneNumber,
      errandTypeId,
      websiteId: id,
      apartmentNumber: apartmentNumber ?? '',
    }).then(({ data }) => {
      if (data?.errandCreate?.error) {
        toast.error(data.errandCreate.error)
        return
      }

      onSuccess()
    })
  }

  return {
    errors,
    onSubmit: handleSubmit(handleCreateErrand),
    register,
    isValid,
    categories: errandTypes.map(({ id, displayName }) => ({ value: id, label: displayName })) ?? [],
    loading,
    hasErrandsFeature,
    errandInfo,
  }
}
